module.exports = __webpack_public_path__ + "static/logo-bf19609d2ba9d5479cef3e3096fc8b1e.svg";